import { ToyboxRays } from './ToyboxRays';
import { ToyboxUnlock } from './ToyboxUnlock';

export class InteractionUnlock extends Phaser.GameObjects.Layer {
  constructor(scene, config) {
    super(scene);

    scene.add.existing(this);
    this._config = config;
    this.background = this.scene.add.image(910, 390, 'background_pattern');

    this.rays = new ToyboxRays(scene, 910, 550);
    this.rays.alpha = 0;

    this.toybox = new ToyboxUnlock(this.scene, 0, 0, this._config.id);
    this.toybox.x = 910;
    this.toybox.y = 1440;
    this.toybox.once('complete', this.handleToyboxComplete, this);
    this.toybox.once('open', () => this._showToyboxBackground(true), this);
    this.toybox.once('close', () => this._showToyboxBackground(false), this);

    this.maskGraphics = this.scene.make.graphics().setScale(0);
    this.maskGraphics.fillStyle(0xff0000);
    this.maskGraphics.fillCircle(0, 0, this.scene.game.defaultWidth * 0.55);
    this.maskGraphics.x = this.scene.game.defaultWidth * 0.5;
    this.maskGraphics.y = this.scene.game.defaultHeight * 0.5;

    this.background.mask = this.maskGraphics.createGeometryMask();

    this.add([this.background, this.rays, this.toybox]);

    this.startState();
  }

  startState() {
    this.scene.tweens.chain({
      tweens: [
        {
          targets: this.maskGraphics,
          scale: { from: 0, to: 1 },
          duration: 750,
          ease: Phaser.Math.Easing.Quadratic.Out,
        },
        {
          targets: this.toybox,
          y: 700,
          ease: Phaser.Math.Easing.Back.Out,
          duration: 1000,
          onComplete: () => {
            console.log('SHOW RAYS');
            this.rays.spin(true);
            this.rays.alpha = 1;

            this.toybox.unlockItem();
          },
        },
      ],
    });
  }

  handleToyboxComplete() {
    this.scene.tweens.chain({
      tweens: [
        {
          targets: this.rays,
          alpha: 0,
          duration: 150,
          ease: Phaser.Math.Easing.Back.In,
        },
        {
          targets: this.toybox,
          y: 1200,
          duration: 750,
          ease: Phaser.Math.Easing.Back.In,
        },
        {
          delay: 1000,
          targets: this.maskGraphics,
          scale: { from: 1, to: 0 },
          duration: 750,
          ease: Phaser.Math.Easing.Quadratic.Out,
          onComplete: () => this.emit('complete'),
        },
      ],
    });
  }

  _showToyboxBackground(value) {
    // this.scene.tweens.killTweensOf(this.backgroundToybox);
    // this.scene.tweens.add({
    //   targets: this.backgroundToybox,
    //   alpha: value ? 1 : 0,
    //   duration: 250,
    // });
  }
}
